import classNames from 'classnames'
import LeftColumn from 'components/Atoms/Calculator/LeftColumn'
import RightColumn from 'components/Molecules/Calculator/RightColumn'

export default function CalculatorComplete() {
  const containerClass = classNames(
    'grid',
    'grid-cols-1',
    'gap-6',
    'md:grid-cols-2',
    'w-full',
    'max-w-screen-xl',
    'bg-gradient-to-br from-black via-blue-800 to-green-800',
    'p-5',
    'sm:p-10',
    'sm:rounded-xl',
  )

  return (
    <div className={containerClass}>
      <LeftColumn />
      <RightColumn />
    </div>
  )
}
